<template>
  <div>
    <div id="chart-container" class="by-moat">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-moat-e-chart" class="chart-row">
        <profile-chart-header
            :title="title +' | ' + titleSuffix"
            :content-list="contentList"
            :content-name="'Match Moat Profile'"
            :display="this.$parent.getDisplayView() && getDisplayView()"
            :input-display-number-of-responses="eChartCriteria.displayNumberOfResponses"
            :input-show-tooltip="eChartCriteria.showTooltip"
            @set-display-number-of-responses="setDisplayNumberOfResponses"
            @set-show-tooltip="setShowTooltip"
        />           
        <profile-chart ref="eChart"
            :e-chart-mini-id="'profile-match-chart-moat-mini'"
            :e-chart-id="'profile-match-chart-moat'"
            :input-report-type-name="'Chart - Match Moat Profile'"
            :modal-id="'profile-by-moat-chart'"
            :is-saved-card="$parent.clientChart.clientChartId != 0" 
            :input-client-chart="this.$parent.clientChart"
            :inputDownloadFileName="downloadFileNameTitle"
            @save-table="saveProfileDataTable"
            @save-criteria="buildClientChart"
            @update-recommendation-data="updateRecommendationsData"/>        
            <!-- 
              :raw-data="{data: finalNeedsData}" 
            -->
      </div>           
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="moatNeedsTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
          <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 50%"/>
        </div>
        <chart-data-table
          ref="moatDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.moatNeedsTable.data"
          :display-direction="'vertical'"
          :data-container-id="moatNeedsTable.tableContainerId"
          :container-id="'profile_match_by_moat_functional_chart'"
          :is-saved-card="$parent.clientChart.clientChartId != 0"           
          :column-defs="this.chart.columnDefs"
          :table-class="'table display row-border table-hover'"
          :table-width="'auto'"
          :report-page-type-name="'Table - Match Moat Profile'"
          :insight-modal-id="'profile-by-moat-table'"
          :content-list="this.pageContentForMoats"          
          :table-title="this.moatNeedsTable.title"
          :inputDownloadFileName="downloadFileNameTitle"
          :effort-list="needsEffortList"
          :use-alternate-title="true"
          @display-initiatives="$parent.displayInitiativesForProfileTable"
          @go-to-explore="$parent.goToExploreForProfileTable"
        ></chart-data-table>
      </div>
    </div>
    <div v-for="(pageContent, idxPageContent) in pageContentForMoats" v-bind:key="idxPageContent">
      <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
    </div>
    
    <insights
      ref="insightsChart"
      :modal-name="'profile-by-moat-chart'"
      :report-page-type-name="'Chart - Match Moat Profile'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsTable"
      :modal-name="'profile-by-moat-table'"
      :report-page-type-name="'Table - Match Moat Profile'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ProfileChart from "../../../views/echarts/ProfileChart.vue";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";
import ProfileService from "../../../services/echarts/profile.service";



import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
import ContentService from "../../../services/content.service";

export default {
  name: "MatchByMoat",
  mixins: [ChartCompanyMixins],
  components: {ProfileChart, ProfileChartHeader},
  data() {
    return {
      displayType: "match-moat",
      pageContentForMoats: [],
      needsEffortList: [],
      moatNeedsTable: {
        id: "",
        data: {},
        title: '<div class="title"><h4 class="text-primary">Moat Profile</h4></div>',
        tableContainerId: "profile_by_moat_data_container"
      },
      isMobile: false,
      titleSuffix: "",
      title: "Match Moat Profile",
      downloadFileNameTitle: "Match Moat Profile",
    };
  },
  props: {
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    topAttributeRecommendationsLegendName: {
      type: String,
      default: "Insights"
    },
    topAttributeRecommendationsData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    matchType: {
      type: String,
      default: ""
    }
  },
  computed: {
    surveyCode: function() {
      return this.$parent.$data.survey.surveyCode;
    },    

  },
  mounted() {},
  created() {
    ContentService.getPageContent("Moats", this.getPageContentByMoatsCallBack, this);
  },
  methods: {
    async saveInstantReportChartImage(clientReportId) {
      if (clientReportId != 0) {
        await this.$refs.eChart.saveImageForInstantReport(clientReportId,'Match Moat Profile | ' + this.titleSuffix);
      }
    },
    getPageContentByMoatsCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContentForMoats = response.data.data;
      }
    },
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Match Moat Profile") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Match Moat Profile") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    async processChartData() {
      try {
        if(this.matchType == "time-period") {
          this.title = "Improvements";
        } else if(this.matchType == "saved-card") {
          this.title = "Variations";
        } else {
          this.title = this.survey.name;
        }
        if (this.$parent.clientChart.clientChartId != 0) {
          this.downloadFileNameTitle = this.$parent.clientChart.name;
        } else {
          this.downloadFileNameTitle = this.title; // saved card name will be used for download file name
        }
        this.chart = ChartService.getChartAttributes("Match By Moat");
        this.$parent.pageContent.push(...this.contentList);
        this.pageContentForMoats.push(...this.contentList);
        let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
        let otherData = needsData["otherData"];
        this.needsEffortList = otherData["effortList"]; 
        let needsList = otherData["needsList"];
        let moatsList = otherData["moatsList"];
        let titleSuffix = otherData["titleSuffix"];
        let emotionalNeedNamesMap = otherData["emotionalNeedNamesMap"];
        if (typeof titleSuffix != "undefined" && titleSuffix != null && titleSuffix != "") {
          this.titleSuffix = titleSuffix;
        }

        let companyColorList = otherData["companyColorList"];
        let breakPointList = otherData["breakPointList"];
        TableService.setCompanyColorList(companyColorList);

        let containerId = needsData["containerId"];

        let chartContainerWidth = $("#" + containerId).width();
        if (chartContainerWidth < ChartService.getMobileBreakpoint()) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }

        this.table.id = containerId;

        NeedsService.setMoatsList(moatsList);
        ChartService.setVerticalLineBreakPoints(breakPointList);
        let copyOfChartData = JSON.parse(JSON.stringify(needsData));

        let emotionalNeedsData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[1])));
        let originalEmotionalNeedsData = JSON.parse(JSON.stringify(this.chartData[1]));
        copyOfChartData.rows.push(...originalEmotionalNeedsData.rows);

        this.$parent.setChartResults(needsData.companyList);
        this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");

        this.moatNeedsTable.id = containerId;
        let labelIndex = 1;
        for (let indexRows = 0; indexRows < copyOfChartData.rows.length; indexRows++) {
          let copyOfChartDataRow = copyOfChartData.rows[indexRows].c;
          let originalName = copyOfChartDataRow[labelIndex].v;
          if (originalName != null && originalName.includes(",")) {
            let emotionalNeedMap = emotionalNeedNamesMap.find(item => item.needName === originalName);
            if (typeof emotionalNeedMap != "undefined") { 
              copyOfChartDataRow[labelIndex].v = emotionalNeedMap.dimensionName;
            } 
          }
        }
        let columns = needsData["cols"];
        this.chart.columnDefs = this.buildColumns(columns,this.chart.columnDefs);

        NeedsService.setFunctionalNeedsList(needsList);
        const emotionalNeedsList = needsList
          .filter(need => need.needType === "emotional")
          .map(need => {
            const emotionalNeedMap = emotionalNeedNamesMap.find(
              item => Number(item.needNumber) === Number(need.needNumber)
            );
            const dimensionName = emotionalNeedMap?.dimensionName || need.dimensionName;
            return {
              ...need,
              dimensionName,
              needName: dimensionName || need.needName
            };
          });
        NeedsService.setEmotionalNeedsList(emotionalNeedsList);
        this.moatNeedsTable.data = copyOfChartData;
        this.$root.$emit("check-number-of-responses");
        this.setEChartCriteria(this.$parent.$refs.chartCriteria.eChartCriteria);
        this.eChartCriteria.eChartType = "stacked-bar-vertical";
        this.parseMatchProfileDataForMoat(JSON.parse(JSON.stringify(this.chartData)));
        this.sortData();

        // for AI Profile Recommendations
        this.setRecommendationsData(copyOfChartData, true);
        this.processTopAttributeRecommendationsdData();        
        this.$refs.eChart.processChart(true,"match-moat",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower,this.$parent.$refs.chartCriteria.matchType);
        $("#cp-by-moat-e-chart").addClass("chart-wrapper");
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
      } catch (err) {
        ErrorService.processException("ProfileMatch.displayChartCallback", err, "chart", this);
      }
    },
    processTopAttributeRecommendationsdData: function(){
      if (!$.isEmptyObject(this.topAttributeRecommendationsData)) {
        this.eChartData.topAttributeRecommendations = (JSON.parse(JSON.stringify(this.topAttributeRecommendationsData)));
        this.eChartData.topAttributeRecommendationsLegendName = this.topAttributeRecommendationsLegendName;
        if (this.chartData.length == 0) {
          return;
        }
        this.$refs.eChart.processChart(true,"match-moat",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower,this.$parent.$refs.chartCriteria.matchType);
      }
    },
    buildColumns: function(columns,baseColumns) {      
        let returnColumns = [];
        // add the first 3 columns from baseColumns to returnColumns
        for (let i = 0; i < 3; i++) {
          returnColumns.push(baseColumns[i]);
        }
        let position = 0;
        columns.forEach(function(column) {
          if (position >= 3){
            if (column.id == "wtp"){
              returnColumns.push(TableService.getPercentTableAttribute([position], "dt-right", 50, 2));
            } else {
              returnColumns.push(TableService.getNumericTableAttribute([position], "dt-right", 50));
            }
          }
          position++;
        });
        return returnColumns;
    },
    sortData:function() {
        let columnIndex = 1;
        let chart2Data = this.eChartData.chart2.data;
        chart2Data.sort((a, b) => {
          let aValue = parseFloat(a[columnIndex]);
          let bValue = parseFloat(b[columnIndex]);
          if (isNaN(aValue)) {
            aValue =  0; 
          }
          if (isNaN(bValue)) {
            bValue = 0; 
          }
          return bValue - aValue; // descending 
        });
        this.eChartData.chart2.data = JSON.parse(JSON.stringify(chart2Data));
    },
   parseMatchProfileDataForMoat: function(inputData){
      let itemsToRemove = {
        firstColumns: 1        
      };
      let itemsToRemoveEmotionalNeeds = {
        firstColumns: 1 ,
        lastRows: 3       
      };
      let data = {};
      let chart1Data = inputData[0];
      let chart2Data = inputData[1];
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseData(2,chart2Data,data,itemsToRemoveEmotionalNeeds);
      data = ProfileService.parseLegendAndColorData(chart1Data,data,false);
      this.eChartData = JSON.parse(JSON.stringify(data));
    },    
    
    saveAllReportPages() {
      this.saveProfileDataTable();
    },    
    async saveProfileDataTable() {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        let vm = this;
        setTimeout(function() {
          ReportService.saveReportTableFile(vm.$refs.moatDataTable.getTableData(),"Table - Match Moat Profile",vm.$parent.clientChart,vm.saveReportTableFileCallback,vm);
          ReportService.saveReportPage(vm.getReportTableContent("profile_match_by_moat_functional_chart"),"Table - Match Moat Profile",vm.$parent.clientChart,vm.saveReportPageCallback,vm);        
        }, 1500);           
      }
    },    
  },
  watch: {
    surveyCode: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChart.clear();} catch(e){}
    },
    topAttributeRecommendationsData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "moat") {
        this.processTopAttributeRecommendationsdData();
      }
    },
    chartData: function() {
      if (this.$parent.$refs.chartCriteria.$data.displayType == "moat") {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
